import { render } from "./PositionsInfo.vue?vue&type=template&id=2cf90b88&scoped=true"
import script from "./PositionsInfo.vue?vue&type=script&lang=js"
export * from "./PositionsInfo.vue?vue&type=script&lang=js"

import "./PositionsInfo.vue?vue&type=style&index=0&id=2cf90b88&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf90b88"]])

export default __exports__